import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { ChequeProvider } from './context/ChequeContext';
import { DepositoProvider } from './context/DepositoContext';
import { NotificationProvider } from './context/NotificationContext';
// Configurar dayjs con timezone America/Guayaquil (GMT-5)
import './config/dayjs';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
  },
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
          <NotificationProvider>
            <AuthProvider>
              <ChequeProvider>
                <DepositoProvider>
                  <App />
                </DepositoProvider>
              </ChequeProvider>
            </AuthProvider>
          </NotificationProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
